// extracted by mini-css-extract-plugin
export default {"input":"radio_input-module__input--3Bu5R"};